
import { Component, Vue } from 'nuxt-property-decorator'
import BPSection from './snippets/BPSection.vue'
import BPSectionHeader from './snippets/BPSectionHeader.vue'

const HowItWorksCards = () => ({
  component: import(
    /* webpackChunkName: "sections" */ '~/components/sections/how-it-works/Cards.vue'
  ),
  delay: 200,
  timeout: 3000,
})
const HowItWorksCardsItem = () => ({
  component: import(
    /* webpackChunkName: "sections" */ '~/components/sections/how-it-works/CardsItem.vue'
  ),
  delay: 200,
  timeout: 3000,
})

@Component({
  components: {
    BPSection,
    BPSectionHeader,
    HowItWorksCards,
    HowItWorksCardsItem,
  },
})
export default class BPHiw extends Vue {
  items = [
    {
      icon: 'hiw-card__icon--find-bf',
      text: 'howItWorks.cards.card1',
      isActive: false,
      id: 1,
    },
    {
      icon: 'hiw-card__icon--payout-bf',
      text: 'howItWorks.cards.card2',
      isActive: false,
      id: 2,
    },
    {
      icon: 'hiw-card__icon--face-bf',
      text: 'howItWorks.cards.card3',
      isActive: false,
      id: 3,
    },
    {
      icon: 'hiw-card__icon--deliver-bf',
      text: 'howItWorks.cards.card4',
      isActive: true,
      id: 4,
    },
  ]
}
